import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import { Alert, Container } from "@mui/material"
import Avatar from "@mui/material/Avatar"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import CssBaseline from "@mui/material/CssBaseline"
import Grid from "@mui/material/Grid"
import { createTheme } from "@mui/material/styles"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import authService from "services/authService"
import * as Yup from "yup"

const _theme = createTheme()
interface IForgotPasswordValues {
  email: string
}

export function ForgotPassword() {
  const navigate = useNavigate()
  const [error, setError] = useState<string>()
  const [_errorVisible, setErrorVisible] = useState<boolean>()
  const search = useLocation().search

  // biome-ignore lint/correctness/useExhaustiveDependencies: formik is stable and doesn't need to be in deps
  useEffect(() => {
    const emailParam = new URLSearchParams(search).get("email") || ""
    formik.setFieldValue("email", emailParam)
  }, [search])

  const initialValues: IForgotPasswordValues = {
    email: "",
  }

  const changePasswordValidationScheme = Yup.object({
    email: Yup.string().required("Please enter your email"),
  })

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: changePasswordValidationScheme,
    onSubmit: (values) => {
      const changeUserPassword: IForgotPasswordValues = {
        email: values.email,
      }

      authService
        .forgotPassword(changeUserPassword.email)
        .then((response) => {
          if (response.nextStep.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE") {
            navigate("/change-password")
          }
        })
        .catch((err) => {
          setError(err.message)
          setErrorVisible(true)
        })
    },
  })

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5" paddingBottom={4}>
          Forgot password
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="email"
                name="email"
                required
                fullWidth
                id="email"
                label="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
          </Grid>
          {error !== undefined && <Alert severity="error">{error}</Alert>}
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Send
          </Button>
        </form>
      </Box>
    </Container>
  )
}
